<template>
<img src="../../assets/blur_office.jpg" style="object-fit: cover; height:100%; width:100%;" />
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps([
	'settings',
]);
console.log(props.settings);

</script>
